module.exports = __webpack_public_path__ + "static/media/car-missing.49976a1d.png";